<template>
 <v-layout
    justify-center
    class="activity"
    :style="{ 'width': isSimulation ? '375px' : `${sizeW}px !important`}"
    style="background-color: black;"
    v-if="menuID === expandMenuID"
  >
    <parrilla 
      v-if="items && items.length >0"
      :data="items"
      :onFinished="handleFinished"
      :loop="true"
    />
    <v-img
      v-if="ShowMoscaDFeel"
      style="position:absolute;opacity:0.8"
      :style="{ 'left': isDesktop && !isSimulation ? '410px' : '10px' }"
      :width="isDesktop && !isSimulation ? '1200px' : '600px'"
      :src="'./img/MOSCA DFEEL CHANNEL.png'"
    />
  </v-layout>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import axios from 'axios'
  import api from '@/services/api'
  import constants from '@/constants'
  import Parrilla from './Parrilla'
  export default {
    components: {
      Parrilla
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null,
      },
      menuID: {
        type: String,
        required: false,
        default: null
      }
    },
    data: () => ({
      DviewLinkParrilla: null,
      ShowMoscaDFeel: false,
      items: null,
      numItem: 0,
      active: 0 
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'BGColorContent', 'BGColor', 'ColorContent']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile();
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },
      expandMenuID () {
        return this.$store.state.app.expandMenuID
      }
    },
    mounted () {
      this.getEnterprise()
    },
    methods: {
      getEnterprise () {
        api.getItem('enterprises', false, this.$store.state.app.enterpriseID).then(response => {
          this.DviewLinkParrilla = response.DviewLinkParrilla
          this.ShowMoscaDFeel = response.ShowMoscaDFeel

          this.handleGetParrilla()
        })
      },
      handleGetParrilla () {    
        this.activities = axios.get(`https://www.dviewcontent.com/api/p_parrilla/${this.DviewLinkParrilla}/dtouch`)
          .then(response => {
            this.items = response.data && response.data ? response.data : []
          })
      },
      handleFinished () {
        console.log('finish')
      }
    }
  }
</script>
<style scoped>
  .activity .container {
    padding: 0px;
  }
  .layout.activity.justify-center {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  .activity .v-toolbar__content {
    padding: 0px !important;
    margin: auto !important;
  }
  .activity-button {
    margin-left: 10px;
  }
  .activity-button:hover {
    opacity: 0.7;
  }
  .td:hover {
    cursor: pointer;
  }
</style>
